import { useQuery } from '@tanstack/react-query';

import { getMonthlyBillDetail } from '@/apis/company';
import { QUERY_KEY } from '@/constants/queryKey';

const useMonthlyBillDetail = (billId: number | null) => {
  const query = useQuery(
    [QUERY_KEY.MONTHLY_BILL_DETAIL, billId],
    () => getMonthlyBillDetail(billId!),
    {
      enabled: billId !== null,
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );

  return query;
};

export default useMonthlyBillDetail;

